import { render, staticRenderFns } from "./DevHeader.vue?vue&type=template&id=11a6ffc9&scoped=true"
import script from "./DevHeader.vue?vue&type=script&lang=js"
export * from "./DevHeader.vue?vue&type=script&lang=js"
import style0 from "./DevHeader.vue?vue&type=style&index=0&id=11a6ffc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6ffc9",
  null
  
)

export default component.exports